import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c01ff49&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/landing-page/_landing-page.scss?vue&type=style&index=0&id=1c01ff49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01ff49",
  null
  
)

export default component.exports